/**
 * When set to `true` on a request's `HttpContext`, the global
 * error-feedback interceptor skips its toast and simply rethrows, letting
 * the component surface the error inline. Defaults to `false`.
 *
 * Usage:
 *   http.post(url, body, { context: new HttpContext().set(SKIP_FEEDBACK, true) });
 *
 * The token itself now lives in the kit (`src/app/ui/core/feedback.context.ts`)
 * so the vendor portal and the admin dashboard share ONE identity — an
 * HttpContextToken is compared by reference, so two copies of the same source
 * would silently never match. This file is kept as the import path every
 * existing call site already uses; the re-export is the whole of it.
 */
export { SKIP_FEEDBACK } from '../../ui/core/feedback.context';
